import { useEffect, useCallback } from "react";
import { useImmer } from "use-immer";
import { fetchWithURL } from "src/apis/main";
import { INITIAL_PAGINATION_DATA } from "src/constants";

export default function withCursorPagination(WrappedComponent) {
  return function ({ url, ...others }) {
    const [loading, setLoading] = useImmer(false);
    const [paginationData, setPaginationData] = useImmer(
      INITIAL_PAGINATION_DATA
    );
    const [message, setMessage] = useImmer("");

    useEffect(() => {
      const getData = async function () {
        await setPaginationData(INITIAL_PAGINATION_DATA);
        setLoading(true);
        await handleFetch(url);
        setLoading(false);
      };
      getData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url]);

    const handleFetch = useCallback(async (url) => {
      const response = await fetchWithURL(url);
      const { data, links, meta } = response.data;
      if (Array.isArray(data)) {
        if (paginationData.data.length === 0 && data.length === 0) {
          setMessage("empty");
        } else {
          setPaginationData((draft) => {
            draft.data.push(...data);
            draft.links = links;
            draft.meta = meta;
          });
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNextPage = useCallback(async (url) => {
      await handleFetch(url);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUpdateItem = useCallback(({ by, byValue, objectToUpdate }) => {
      setPaginationData((draft) => {
        let item = draft.data.find((i) => i[by] === byValue);
        Object.keys(objectToUpdate).map((k) => (item[k] = objectToUpdate[k]));
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <WrappedComponent
        message={message}
        loading={loading}
        paginationData={paginationData}
        handleNextPage={handleNextPage}
        handleUpdateItem={handleUpdateItem}
        {...others}
      />
    );
  };
}
